export const countries = (state) => state.countries;
export const shippingMethods = (state) => state.shippingMethods;
export const paymentMethods = (state) => state.paymentMethods;
export const country = (state) => state.country;
export const shippingMethod = (state) => state.shippingMethod;
export const paymentMethod = (state) => state.paymentMethod;
